import { render, staticRenderFns } from "./LmBox.vue?vue&type=template&id=24c9910a&scoped=true&"
import script from "./LmBox.vue?vue&type=script&lang=js&"
export * from "./LmBox.vue?vue&type=script&lang=js&"
import style0 from "./LmBox.vue?vue&type=style&index=0&id=24c9910a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c9910a",
  null
  
)

export default component.exports